import { ENVIRONMENTS, getCurrentEnvironment } from '@/utils/environmentUtils';

const DOMAINS = {
  AWS: '.aws.pmicloud.biz',
  PROD: '.pmaktif.com',
};

const SUBDOMAINS = {
  [ENVIRONMENTS.QA]: '.pmaktiftr',
  [ENVIRONMENTS.DEV]: '.pmaktiftr',
  [ENVIRONMENTS.PROD]: '',
};

const ENV_PREFIXES = {
  [ENVIRONMENTS.QA]: '-qa',
  [ENVIRONMENTS.DEV]: '-dev',
  [ENVIRONMENTS.PROD]: '',
};

/**
 * Build the content URL for the given environment
 */
const buildContentUrl = environment => {
  const domain = environment === ENVIRONMENTS.PROD ? DOMAINS.PROD : DOMAINS.AWS;
  return `https://content${SUBDOMAINS[environment]}${ENV_PREFIXES[environment]}${domain}`;
};

/**
 * Content URL for the current environment
 */
export const CONTENT_URL = buildContentUrl(getCurrentEnvironment());

export const PM_AKADEMI_ASSETS = {
  TOP_BANNER: `${CONTENT_URL}/Files/Pmacademy/top-banner-web.png`,
  MAIN_BANNER: `${CONTENT_URL}/Files/Pmacademy/main-banner-web.jpg`,
  WIDGET_BANNER: `${CONTENT_URL}/Files/Pmacademy/widget-banner.png`,
};

/**
 * PM Akademi centralized configuration
 * Used by routes, menu rendering and academy navigation
 */
export const PM_AKADEMI = {
  PARENT_ID: 463,
  ID: 464,
  DEFAULT_TITLE: 'Mükemmellik Yeniden Tanımlanıyor',
  getRoute: () => `/secure/pm-akademi?parentId=${PM_AKADEMI.PARENT_ID}&id=${PM_AKADEMI.ID}`,
};

export const LEGEND_IFRAME_BASE_URL =
  getCurrentEnvironment() === ENVIRONMENTS.PROD
    ? process.env.VUE_APP_LEGEND_IFRAME_BASE_URL
    : process.env.VUE_APP_LEGEND_IFRAME_BASE_URL_QA;
